// Global auth state reference
let globalAuthChecked = false;

// Export getter and setter for globalAuthChecked
export const getGlobalAuthChecked = () => globalAuthChecked;
export const setGlobalAuthChecked = (value: boolean) => {
  globalAuthChecked = value;
};
